import { render, staticRenderFns } from "./ModalCancelarAta.vue?vue&type=template&id=499a41c0"
import script from "./ModalCancelarAta.vue?vue&type=script&lang=js"
export * from "./ModalCancelarAta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports